import { useTranslation } from "react-i18next";
import type { Column } from "@tanstack/react-table";
import { ArrowDown, ArrowUp, Check, ChevronsUpDown, X } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "components/ui/dropdown-menu";

function SortableHeader<TData>({ column, children }: { column: Column<TData, unknown>; children: React.ReactNode }) {
    const { t } = useTranslation();
    const sort = column.getIsSorted();
    const SortIcon = sort === "asc" ? ArrowUp : sort === "desc" ? ArrowDown : ChevronsUpDown;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button type="button" className="tw-flex tw-items-center tw-gap-1 tw-whitespace-nowrap tw-font-medium hover:tw-text-foreground">
                    {children}
                    <SortIcon className="tw-h-3.5 tw-w-3.5 tw-shrink-0 tw-text-muted-foreground" />
                </button>
            </DropdownMenuTrigger>

            <DropdownMenuContent align="start">
                <DropdownMenuItem onClick={() => column.toggleSorting(false)}>
                    <ArrowUp className="tw-h-4 tw-w-4" />
                    {t("asc")}
                    {sort === "asc" && <Check className="tw-ml-auto tw-h-4 tw-w-4" />}
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => column.toggleSorting(true)}>
                    <ArrowDown className="tw-h-4 tw-w-4" />
                    {t("desc")}
                    {sort === "desc" && <Check className="tw-ml-auto tw-h-4 tw-w-4" />}
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => column.clearSorting()}>
                    <X className="tw-h-4 tw-w-4" />
                    {t("reset")}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}


export default SortableHeader;
